import { render, staticRenderFns } from "./HeaderP2P.vue?vue&type=template&id=25bd8624&scoped=true&"
import script from "./HeaderP2P.vue?vue&type=script&lang=js&"
export * from "./HeaderP2P.vue?vue&type=script&lang=js&"
import style0 from "./HeaderP2P.vue?vue&type=style&index=0&id=25bd8624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bd8624",
  null
  
)

export default component.exports